// Multi-Voice Demo Configuration for Enhanced Landing Page

export const MULTI_VOICE_DEMO_CONFIG = {
  // Individual voice demo text - A Tale of Two Cities opening (Charles Dickens, 1859 - Public Domain)
  individualVoiceText: `It was the best of times, it was the worst of times, it was the age of wisdom, it was the age of foolishness, it was the epoch of belief, it was the epoch of incredulity, it was the season of Light, it was the season of Darkness, it was the spring of hope, it was the winter of despair, we had everything before us, we had nothing before us, we were all going direct to Heaven, we were all going direct the other way—in short, the period was so far like the present period, that some of its noisiest authorities insisted on its being received, for good or for evil, in the superlative degree of comparison only.`,

  // Multi-voice demo text (existing content intelligently divided)
  demoText: `It was the age of brilliance, it was the age of shadows, it was the epoch of discovery, it was the epoch of mystery. In this new era of audiobook artistry, every tale becomes a symphony of voices, every story a theatrical masterpiece. The narrator's voice, rich and commanding, guides listeners through realms unknown, while characters emerge with distinct personalities.`,

  voiceAssignments: {
    'Narrator': {
      name: 'Burt Reynolds™',
      id: '4YYIPFl9wE5c4L2eu2Gb',
      description: 'Classic Narrator',
      color: '#D7B377'
    },
    'Storyteller': {
      name: 'Elizabeth',
      id: 'AXdMgz6evoL7OPd7eU12', 
      description: 'Character Voices',
      color: '#E2D7C4'
    },
    'Character Voice': {
      name: 'Nathaniel C',
      id: 'AeRdCCKzvd23BpJoofzx',
      description: 'Full Cast Magic', 
      color: '#C8B280'
    },
    'Literary Guide': {
      name: 'Nova Westbrook',
      id: 'rSZFtT0J8GtnLqoDoFAp',
      description: 'Modern, dynamic female narrator',
      color: '#F0E6D2'
    }
  },

  // Intelligent division of multi-voice demo text between the four voices
  highlights: [
    { start: 0, end: 95, character: 'Narrator', voice: 'Burt Reynolds™', text: 'It was the age of brilliance, it was the age of shadows, it was the epoch of discovery,' },
    { start: 96, end: 140, character: 'Storyteller', voice: 'Elizabeth', text: 'it was the epoch of mystery.' },
    { start: 141, end: 245, character: 'Character Voice', voice: 'Nathaniel C', text: 'In this new era of audiobook artistry, every tale becomes a symphony of voices,' },
    { start: 246, end: 420, character: 'Literary Guide', voice: 'Nova Westbrook', text: 'every story a theatrical masterpiece. The narrator\'s voice, rich and commanding, guides listeners through realms unknown, while characters emerge with distinct personalities.' }
  ]
};

export default MULTI_VOICE_DEMO_CONFIG;